// src/componentes/common/EstadoVista.jsx
//
// UX-1 (2026-06-17): estados estándar de carga / vacío / error para listas y
// paneles. Unifica la experiencia (antes cada pantalla resolvía "Cargando..."
// o el error a su manera, o solo con un toast transitorio).
//
// Uso:
//   if (loading) return <EstadoCarga texto="Cargando panel…" />;
//   if (error)   return <EstadoError onReintentar={cargar} />;
//   if (!items.length) return <EstadoVacio titulo="Sin resultados" />;

import React from "react";
import "./EstadoVista.css";

export function EstadoCarga({ texto = "Cargando…" }) {
  return (
    <div className="estado-vista estado-vista--carga" role="status" aria-live="polite">
      <div className="estado-vista__spinner" aria-hidden="true" />
      <p className="estado-vista__texto">{texto}</p>
    </div>
  );
}

export function EstadoVacio({ icono = "∅", titulo = "Sin resultados", detalle = "" }) {
  return (
    <div className="estado-vista estado-vista--vacio">
      <div className="estado-vista__icono" aria-hidden="true">{icono}</div>
      <p className="estado-vista__titulo">{titulo}</p>
      {detalle && <p className="estado-vista__detalle">{detalle}</p>}
    </div>
  );
}

export function EstadoError({
  titulo = "No se pudo cargar la información",
  detalle = "Revisa tu conexión e intenta de nuevo.",
  onReintentar,
}) {
  return (
    <div className="estado-vista estado-vista--error" role="alert">
      <div className="estado-vista__icono" aria-hidden="true">⚠️</div>
      <p className="estado-vista__titulo">{titulo}</p>
      {detalle && <p className="estado-vista__detalle">{detalle}</p>}
      {onReintentar && (
        <button type="button" className="estado-vista__btn" onClick={onReintentar}>
          Reintentar
        </button>
      )}
    </div>
  );
}
